import { FC, useEffect, useState } from 'react';

import { fileBucketUrl } from '@shared/utils/fileUtils';
import { Image as AntImage } from 'antd';

//* 버킷 이미지 한 장 — 축소본으로 띄우고 클릭하면 원본.
//*
//* 축소본(w200·w400…)은 업로드 시 리사이즈 파이프라인이 만들어 둔 **파생 파일**이라,
//* 그게 없는 이미지(서명처럼 작게 올라간 것, 파이프라인 이전에 올라간 옛 파일)는
//* 축소본 URL이 404가 난다. 그래서 실패하면 **원본으로 한 번 되돌린다** —
//* 이 폴백이 없으면 "이미지가 안 뜬다"로만 보이고 원인이 안 보인다.
//*
//* 값이 이미 절대 URL(http…)이면 버킷 경로를 붙이지 않고 그대로 쓴다.

const isAbsolute = (value: string) => /^(https?:|data:|blob:)/.test(value);

const toUrl = (value: string, size: string) =>
  isAbsolute(value) ? value : fileBucketUrl(value.replace(/^\//, ''), size);

export interface BucketImageProps {
  /** 버킷 키 또는 절대 URL. 없으면 아무것도 그리지 않는다 */
  value?: string;
  /** 목록용 축소본 크기 (기본 w400) */
  size?: string;
  width?: number;
  height?: number;
  className?: string;
  alt?: string;
  /** 클릭 확대 여부 (기본 true — 원본으로 띄운다) */
  preview?: boolean;
}

export const BucketImage: FC<BucketImageProps> = function BucketImage({
  value,
  size = 'w400',
  width,
  height,
  className,
  alt = '이미지',
  preview = true,
}) {
  const [useRaw, setUseRaw] = useState(false);

  //* 다른 행의 이미지로 바뀌면 폴백 상태도 초기화 (안 하면 한 번 실패한 뒤로 전부 원본을 받는다)
  useEffect(() => setUseRaw(false), [value]);

  if (!value) return null;

  const src = toUrl(value, useRaw ? 'raw' : size);

  return (
    <AntImage
      src={src}
      {...(preview ? { preview: { src: toUrl(value, 'raw') } } : { preview: false })}
      {...(width ? { width } : {})}
      {...(height ? { height } : {})}
      className={className}
      alt={alt}
      onError={() => setUseRaw(true)}
    />
  );
};
